"use client";
import { useState as y, useCallback as n } from "react";
import { fileMatchesAccept as B } from "../../../utils/utils.mjs";
const F = (l, E = {}) => {
  const { accept: o, maxSizeBytes: i, onFileSelected: m, error: S, onError: f } = E, [h, t] = y("default"), [k, p] = y(null), [v, c] = y(null), [w, a] = y(null), _ = S ?? v, x = _ && h !== "loading" ? "error" : h, g = n(
    (e, r, s) => {
      const M = f == null ? void 0 : f({ type: e, file: r, defaultMessage: s });
      return typeof M == "string" ? M : s;
    },
    [f]
  ), u = n(() => {
    t("default"), p(null), c(null), a(null), l.current && (l.current.value = "");
  }, [l]), P = n(() => {
    var e;
    (e = l.current) == null || e.click();
  }, [l]), d = n(
    async (e) => {
      if (o != null && o.length && !B(e, o)) {
        const r = `Unsupported file type. Please upload a ${o.join(", ")} file.`;
        t("error"), a("unsupported_type"), c(g("unsupported_type", e, r)), p(null);
        return;
      }
      if (i && e.size > i) {
        const r = `File exceeds the ${Math.round(i / 1024 / 1024)} MB limit. Please upload a smaller file.`;
        t("error"), a("file_too_large"), c(g("file_too_large", e, r)), p(null);
        return;
      }
      if (p(e), c(null), a(null), m) {
        t("loading");
        try {
          await m(e), t("success");
        } catch (r) {
          const s = r instanceof Error ? r.message : "An error occurred processing the file";
          t("error"), a("processing_error"), c(g("processing_error", e, s));
        }
      } else
        t("success");
    },
    [o, i, m, g]
  ), z = n(
    async (e) => {
      var s;
      const r = (s = e.target.files) == null ? void 0 : s[0];
      if (!r) {
        u();
        return;
      }
      await d(r);
    },
    [d, u]
  ), A = n(
    async (e) => {
      const r = e[0];
      if (!r) {
        u();
        return;
      }
      await d(r);
    },
    [d, u]
  );
  return { state: x, file: k, error: _, errorType: w, handleChange: z, handleDrop: A, openFilePicker: P, reset: u };
};
export {
  F as useFileInput
};
